import React from 'react';
import { BellIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
const days: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const rows: string[] = ['9:00', '10:00', '11:00', '12:00'];
const badges: string[] = ['Territory: 85254', 'Round robin: Jordan'];
const ladder: {
  label: string;
  icon: 'check' | 'bell';
}[] = [{
  label: 'Instant confirm sent',
  icon: 'check'
}, {
  label: 'Reminder 24h',
  icon: 'bell'
}, {
  label: 'Reminder 2h',
  icon: 'bell'
}];
export function CalendarVignette() {
  return <VignetteFrame label="Team calendar" timestamp="This week" data-id="element-264" data-mp="2npyipxvjggzt">
      <div className="grid grid-cols-[38px_repeat(7,minmax(0,1fr))] gap-1" data-id="element-265" data-mp="2no47xcdze59g">
        <span aria-hidden="true" data-id="element-266" data-mp="2jp4vl6px767z" />
        {days.map(day => <span key={day} className={`pb-2 text-center text-[11px] font-semibold uppercase tracking-[0.08em] ${day === 'Sat' ? 'text-brand' : 'text-white/35'}`} data-id="element-267" data-mp="tbnwzya8q2y9">
            {day}
          </span>)}

        {rows.map((row, rowIndex) => <React.Fragment key={row} data-id="element-268" data-mp="2giw3i262qj4k" data-mpi={rowIndex}>
            <span className="pr-1 pt-1 text-right text-[10px] tabular-nums text-white/30" data-id="element-269" data-mp="2gfrrwjqa4l3v">
              {row}
            </span>
            {days.map(day => {
          const isSlot = day === 'Sat' && row === '10:00';
          if (isSlot) {
            return <Reveal key={day + row} delay={0.35} offset={8} data-id="element-270" data-mp="2v67d3yip3t21">
                    <div className="h-11 rounded-md border border-brand/50 bg-brand/20" data-id="element-271" data-mp="2z7kjqatm40a0" />
                  </Reveal>;
          }
          return <div key={day + row} className={`h-11 rounded-md border border-white/5 ${rowIndex % 2 === 0 ? 'bg-white/[0.03]' : 'bg-white/[0.015]'}`} data-id="element-272" data-mp="396i3z1k097n7" />;
        })}
          </React.Fragment>)}
      </div>

      <Reveal delay={0.5} className="mt-5 rounded-xl border border-brand/30 bg-brand/10 px-4 py-3" data-id="element-273" data-mp="16r9nj75qn8hq">
        <p className="text-sm font-semibold text-white" data-id="element-274" data-mp="12rixj5o1cwe9">Saturday 10:00 AM</p>
        <p className="mt-1 text-sm text-white/65" data-id="element-275" data-mp="1gq8venioj03o">Buyer tour, East Cactus listing</p>
        <ul className="mt-3 flex flex-wrap gap-2" data-id="element-276" data-mp="1br5sp9q695yv">
          {badges.map(badge => <li key={badge} className="rounded-full border border-white/15 bg-ink-800 px-3 py-1 text-xs font-medium text-white/70" data-id="element-277" data-mp="1pqngblrqed6n">
              {badge}
            </li>)}
        </ul>
      </Reveal>

      <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 border-t border-white/10 pt-4" data-id="element-278" data-mp="1zfypf8embhuj">
        {ladder.map((item, index) => {
        const Icon = item.icon === 'check' ? CheckIcon : BellIcon;
        return <Reveal key={item.label} delay={0.7 + index * 0.12} offset={6} data-id="element-279" data-mp="29cjutuujuuyw" data-mpi={index}>
              <li className="flex items-center gap-2 text-xs font-medium text-white/55" data-id="element-280" data-mp="24guuvqembc22">
                <Icon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-281" data-mp="2o2oa71qaul7r" />
                {item.label}
              </li>
            </Reveal>;
      })}
      </ul>
    </VignetteFrame>;
}